import React from 'react';
import { TemplatesList } from '../../../../enums/TemplatesList';
import DefaultLocationsSection from '../../../Templates/DefaultTemplate/Sections/Services/LocationsSection/LocationsSection';
import ModerLocationService from '../../../Templates/ModernTemplate/Sections/Services/LocationSection/LocationSection';
import { Section } from '../../../../interfaces/Section';
import { IAppointmentTypes, ILocation } from '../../../../interfaces/professional/Professional';

export interface ServiceLocationsSectionProps extends Section {
  serviceId: string;
  serviceName: string;
  otherLocations: Array<ILocation>;
  primaryLocation: ILocation;
  mobilityRadius: number | null;
  appointmentTypes: Array<IAppointmentTypes>;
  phoneNumber: string;
}

const LocationsSection = (props: ServiceLocationsSectionProps) => {
  if (props.template === TemplatesList.MODERN) {
    return <ModerLocationService {...props} />;
  }
  return <DefaultLocationsSection {...props} />;
};

export default LocationsSection;
